import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

const MUTATION = gql`
  mutation EstablishSessionForOauth($oauth2Consent: String!) {
    establishSessionForOauth(oauth2Consent: $oauth2Consent) {
      redirectUrl
    }
  }
`;

export const establishSessionForOAuth = (oauth2Consent) =>
  executeGqlMutation({
    mutation: MUTATION,
    variables: { oauth2Consent },
    options: { credentials: 'include' },
  }).then(({ data }) => getSingleProp(data));
